import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../clientReview/ClientReview.css';
import useApi from '../../customHook/useApi';

const ClientReview = () => {
    const { id } = useParams();
    const { get } = useApi('https://codezens.com/luststory/index.php/api');
    const [userDetail, setUserDetail] = useState({});

    useEffect(() => {
        const fetchUserDetail = async () => {
            try {
                const response = await get(`/get_user_profile?auth_id=9&user_id=${id}`);
                setUserDetail(response?.result || {}); // Ensure it's always an object
            } catch (err) {
                console.error(err);
            }
        };
        fetchUserDetail();
    }, [get, id]); // Include id in dependency array -

    return (
        <div className='client-review-with-from-sec d-flex flex-wrap'>
            <div className='form-box'>
                <form>
                    <div className='form-group'>
                        <textarea
                            cols="30"
                            rows="3"
                            placeholder='Description'
                            value={userDetail.bio || ""}
                            onChange={() => { }}
                        />
                    </div>
                </form>
            </div>

            <div className='client-review-sec'>
                <div className='client-review-inner-sec'>
                    <div className='top-box-review d-flex justify-content-between align-items-center'>
                        <h2>Reviews ({userDetail.reviews?.length || 0})</h2>
                        <Link to='/' className='view-all'>
                            <span>View All</span>
                            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 6L13 6" stroke="#FD59D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9.76923 11L13 6L9.76923 1" stroke="#FD59D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Link>
                    </div>

                    <div className='client-review-profile d-flex flex-wrap'>
                        {userDetail.reviews?.map((item, index) => (
                            <div className='client-review-details-box' key={item.review_id || index}>
                                <div className='top-details d-flex align-items-center justify-content-between'>
                                    <div className='img-details d-flex align-items-center'>
                                        <img className='img-box' src={item.customer_image} alt='reviewer-img' />
                                        <div className='name-details'>
                                            <p>{item.customer_name}</p>
                                        </div>
                                    </div>
                                    <div className='rating-box d-flex align-items-center'>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.7765 0.503419L13.2284 5.66525C13.2842 5.79628 13.3719 5.90976 13.4829 5.99441C13.5938 6.07904 13.7241 6.13189 13.8607 6.14767L19.2734 6.98385C19.4302 7.00486 19.578 7.07193 19.6995 7.17724C19.821 7.28253 19.9114 7.42173 19.9598 7.57853C20.0084 7.73534 20.013 7.90332 19.9734 8.06282C19.9339 8.22234 19.8515 8.36679 19.736 8.47934L15.8345 12.5155C15.7351 12.6126 15.6603 12.734 15.6172 12.8688C15.5741 13.0036 15.564 13.1475 15.5878 13.2874L16.5285 18.9638C16.5558 19.127 16.5385 19.2947 16.4788 19.4481C16.4191 19.6015 16.3194 19.7343 16.1907 19.8316C16.0623 19.9287 15.9101 19.9863 15.7517 19.9979C15.5933 20.0093 15.435 19.9742 15.2948 19.8964L10.4218 17.211C10.297 17.1471 10.1599 17.114 10.0209 17.114C9.88185 17.114 9.7447 17.1471 9.61991 17.211L4.74688 19.8964C4.60669 19.9742 4.44839 20.0093 4.29001 19.9979C4.13162 19.9863 3.97949 19.9287 3.85096 19.8316C3.72241 19.7343 3.6226 19.6015 3.56289 19.4481C3.5032 19.2947 3.48597 19.127 3.51321 18.9638L4.45388 13.2231C4.47773 13.0832 4.46764 12.9393 4.42455 12.8045C4.38147 12.6697 4.30672 12.5482 4.20715 12.4512L0.259384 8.47934C0.14259 8.36372 0.0604533 8.21525 0.0229248 8.05195C-0.0146037 7.88864 -0.00591237 7.71748 0.0479423 7.55921C0.101799 7.40095 0.198508 7.26237 0.326359 7.16024C0.45421 7.05813 0.607713 6.99685 0.768272 6.98385L6.18103 6.14767C6.31766 6.13189 6.44794 6.07904 6.55888 5.99441C6.66982 5.90976 6.75753 5.79628 6.81329 5.66525L9.26523 0.503419Z" fill="#FD59D9" />
                                        </svg>
                                        <span>{item.rating}</span>
                                    </div>
                                </div>
                                <div className='bottom-details'>
                                    <h2>{item.review}</h2>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientReview;
